import * as request from '../api-request'

export const getUsers = (data) => {
  const queryString = new URLSearchParams(data)
  return request.toJSON('GET', `admin/users_list?${queryString}`, data)
}

export const getSubscribedUsers = (data) => {
  const queryString = new URLSearchParams(data)
  return request.toJSON('GET', `admin/subscribed_users?${queryString}`, data)
}

export const getSingleUsers = (data) => {
  return request.toJSON('POST', 'admin/user_info', data)
}

export const getScripts = (data) => {
  const queryString = new URLSearchParams(data)
  return request.toJSON('GET', `admin/user_scripts?${queryString}`, data)
}

export const getStatistics = (data) => {
  return request.toJSON('GET', 'admin/statistics', data)
}

export const addCredits = (data) => {
  return request.toJSON('POST', 'admin/add_credits', data)
}
